import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function QualificationSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-24 px-6 bg-[#0D0D0D]" data-id="element-132">
      <div className="max-w-3xl w-full mx-auto space-y-16" data-id="element-133">
        {/* ESTO ES PARA TI SI... */}
        <div className="space-y-8" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-135">
            <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-136">
              ESTO ES PARA TI SI...
            </span>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="space-y-5" data-id="element-137">
            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-138">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-139">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-140" />
              </div>
              <div data-id="element-141">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-142">
                  <span className="font-medium" data-id="element-143">
                    Sientes que «tienes todo», pero no sientes nada.
                  </span>{' '}
                  <span className="text-[#A89F91]" data-id="element-144">
                    Sabes que deberías estar agradecida, pero el vacío interno
                    es real.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-145">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-146">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-147" />
              </div>
              <div data-id="element-148">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-149">
                  <span className="font-medium" data-id="element-150">Operas en modo respuesta.</span>{' '}
                  <span className="text-[#A89F91]" data-id="element-151">
                    Tu día consiste en apagar incendios ajenos mientras tus
                    propios deseos están en pausa indefinida.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-152">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-153">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-154" />
              </div>
              <div data-id="element-155">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-156">
                  <span className="font-medium" data-id="element-157">
                    Tu cuerpo envía señales de auxilio.
                  </span>{' '}
                  <span className="text-[#A89F91]" data-id="element-158">
                    Despiertas cansada, tienes neblina mental y el café ya no es
                    suficiente.
                  </span>
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4" data-id="element-159">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#D4A853]/15 flex items-center justify-center" data-id="element-160">
                <Check className="w-3.5 h-3.5 text-[#D4A853]" data-id="element-161" />
              </div>
              <div data-id="element-162">
                <p className="text-[#F5F0E8] text-lg leading-relaxed" data-id="element-163">
                  <span className="font-medium" data-id="element-164">Eres una mujer de acción.</span>{' '}
                  <span className="text-[#A89F91]" data-id="element-165">
                    Buscas un manual práctico de 15 minutos al día, no teoría
                    espiritual compleja.
                  </span>
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} whileInView={{
        scaleX: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#333] to-transparent" data-id="element-166" />

        {/* ESTO NO ES PARA TI SI... */}
        <div className="space-y-8" data-id="element-167">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-168">
            <span className="text-[#A89F91] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-169">
              ESTO NO ES PARA TI SI...
            </span>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="space-y-5" data-id="element-170">
            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-171">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-172">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-173" />
              </div>
              <div data-id="element-174">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-175">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-176">
                    Buscas una «píldora mágica».
                  </span>{' '}
                  Sin el compromiso de 15 minutos diarios, no habrá reinicio.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-177">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-178">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-179" />
              </div>
              <div data-id="element-180">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-181">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-182">
                    Prefieres el victimismo.
                  </span>{' '}
                  Si no estás lista para retomar el mando de tus decisiones,
                  esto te resultará confrontativo.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-183">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-184">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-185" />
              </div>
              <div data-id="element-186">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-187">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-188">
                    Buscas tratados de psicología.
                  </span>{' '}
                  Esto es un protocolo operativo de implementación rápida, no un
                  análisis de tu infancia.
                </p>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="flex items-start gap-4 opacity-70" data-id="element-189">
              <div className="mt-1 shrink-0 w-6 h-6 rounded-full bg-[#A89F91]/10 flex items-center justify-center" data-id="element-190">
                <X className="w-3.5 h-3.5 text-[#A89F91]/60" data-id="element-191" />
              </div>
              <div data-id="element-192">
                <p className="text-[#A89F91] text-lg leading-relaxed" data-id="element-193">
                  <span className="text-[#F5F0E8]/60 font-medium" data-id="element-194">
                    Glorificas el «estar ocupada».
                  </span>{' '}
                  Si no estás dispuesta a soltar el caos, este libro no es para
                  ti.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}